// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarryOutTwoToneSvg from "@ant-design/icons-svg/es/asn/CarryOutTwoTone";
import AntdIcon from '../components/AntdIcon';

var CarryOutTwoTone = function CarryOutTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutTwoToneSvg
  }));
};

CarryOutTwoTone.displayName = 'CarryOutTwoTone';
export default React.forwardRef(CarryOutTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CarryOutTwoTone.js
// module id = 745
// module chunks = 0